import styled from "styled-components"

export interface TableBodyProps {
  fontSize?: string
}

export const TableBody = styled.tbody<TableBodyProps>`
  box-sizing: border-box;
  font-size: ${(props) => props.fontSize};
`

TableBody.defaultProps = {
  fontSize: "12px",
}
